import { FormikProps, getIn } from "formik";

import { ProceedingParticipantSearchResult, ProceedingParticipantType } from "../../../../../api/ClientFileApi";
import { ParticipantSearchSelect } from "../../../../components/participant-search-select/ParticipantSearchSelect";
import { AssetPersonalDataFormValues } from "../../AssetPersonalData.types";

interface Props {
  formik: FormikProps<AssetPersonalDataFormValues>;
  fieldName: "bankId";
  label: string;
  onParticipantChange: (participant: ProceedingParticipantSearchResult | null) => void;
}

/**
 * Search-as-you-type select over proceeding participants of type Bank. The selection is transient
 * (bankId is never persisted) — picking a bank copies its name and address into the account fields.
 */
export function BankParticipantSelect({ formik, fieldName, label, onParticipantChange }: Props) {
  const bankId = getIn(formik.values, fieldName) as string | null;

  return (
    <ParticipantSearchSelect
      label={label}
      type={ProceedingParticipantType.Bank}
      selectedId={bankId}
      onChange={(participant) => {
        void formik.setFieldValue(fieldName, participant?.proceedingParticipantId ?? null);
        onParticipantChange(participant);
      }}
    />
  );
}
